const clean = value => String(value ?? '').trim().replace(/\s+/g, ' ');

export function addressFields(address = {}) {
    const unit = clean(address.UnitTypeNumber);
    const level = clean(address.BuildingLevel);
    let number = clean(address.BuildingNumber) || clean(address.HouseNumber);
    let street = [address.StreetName, address.StreetType, address.StreetSuffix].map(clean).filter(Boolean).join(' ');
    const line = clean(address.AddressLine1);

    // Only split a plain numbered street when structured provider fields are missing.
    // Unit/level abbreviations can differ from AddressLine1, so never replace them blindly.
    if (!unit && !level && (!number || !street)) {
        const match = line.match(/^(\d+[A-Za-z]?(?:\s*[-/]\s*\d+[A-Za-z]?)?)\s+(.+)$/);
        if (match && (!number || number === match[1])) {
            number = number || match[1];
            street = street || match[2];
        }
    }

    const fields = {
        streetNumber: [unit, level, number].filter(Boolean).join(' '),
        streetName: street || line,
        suburb: clean(address.Suburb),
        state: clean(address.State),
        postcode: clean(address.Postcode),
    };
    // Incomplete/ambiguous results must remain editable rather than locking missing data.
    return { ...fields, canLock: Boolean(number && street && fields.suburb && fields.state && fields.postcode) };
}
